import "./Home.css";
import girlImg from "../assets/girl.webp"; // use your image

export default function Home() {
  return (
    <section className="home-section" id="home">

      <div className="home-container">

        {/* LEFT CONTENT */}
        <div className="home-left">
          <h1>
            Sell Your Gold Jewels <br />
            And Avoid Unnecessary Interest Payments
          </h1>

          <h2 className="phone">Call : 8884448033</h2>

          <p>
            Sell your gold jewels at live price with no hidden charges.
            We offer the best price and instant cash. Release pledged
            gold easily and securely.
          </p>

          <button className="cta-btn">To Sell Your Gold</button>
        </div>

        {/* RIGHT IMAGE */}
        <div className="home-right">
          <img src={girlImg} alt="gold" />
        </div>

      </div>

    </section>
  );
}